import { LoginOutlined } from '@ant-design/icons';
import { Button, Card, Table, Tag, Tooltip, Row, Col, Badge } from 'antd';
import React, { Fragment, PureComponent } from 'react';
import router from 'umi/router';
import { FormattedMessage, formatMessage } from 'umi-plugin-react/locale';
import { connect } from 'dva';
import getCloudAccountName from '../../utils/getCloudAccountName';
import NoCloudAccountSelected from '../ReportView/NoCloudAccountSelected/NoCloudAccountSelected';
import FinderSuppressReason from './components/FinderSuppressReason';
import EmptyData from './EmptyData';
import styles from './index.less';
import RenderInnerSignature from './RenderInnerSignature';
import { pushParamsToUrl } from '../../utils/pushParamsToUrl';
import { getHistoricalDate } from '../../utils/getHistoricalDate';
import RenderProgressBar from '../WidgetWrapper/widgets/components/RenderProgressBar';
import { capitalizeFirstLetter } from '../../helpers/capitalizeFirstLetter';
import AllServices from '../../../config/AllServices';

class ResourceRiskTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      paginationConfig: {
        total: 0,
        pageSize: 10,
        current: 1,
        style: { marginRight: 10, bottom: 0 },
        hideOnSinglePage: true,
      },
    };
  }
  openDrawer = (params, drawerType, isCloud) => {
    const { appliedFilters } = this.props;

    let drawerParams = params;

    let isHistoryExist = appliedFilters.find(v => v.type === 'history');

    if (isHistoryExist) {
      drawerParams.push({
        type: 'history',
        value: [isHistoryExist.value[0]],
      });
    }

    // if not receiving cloud account then add selected cloud account ids
    if (!isCloud) {
      // get selected cloud account ids
      const { selectedCloudAccounts } = this.props;
      let filterAccountsId = selectedCloudAccounts.map(val => val.id);

      // push selected cloud account params object in drawerParams
      drawerParams.push({
        type: 'cloudAccounts',
        value: filterAccountsId,
      });
    }

    pushParamsToUrl(drawerParams, drawerType);
  };

  render() {
    let { filteredResources, drawerLoading, showSuppress, appliedFilters, counts } = this.props;

    if (!appliedFilters.find(v => v.type === 'cloudAccounts')) {
      return <NoCloudAccountSelected />;
    }

    if (!showSuppress && filteredResources !== null) {
      filteredResources = getUnSuppressedRisks(filteredResources);
    }

    const columns = this.getTableCloumns();
    return (
      <Fragment>
        <Card
          bodyStyle={{ marginTop: '24px', paddingTop: '0px' }}
          style={{ margin: -46 }}
          bordered={false}
        >
          <Table
            rowKey={record => record?.id}
            scroll={{ y: 'calc(100vh - 400px)' }}
            columns={columns}
            onChange={this.onPaginationChange}
            pagination={this.state.paginationConfig}
            // locale={!drawerLoading && locale && locale}
            loading={filteredResources ? false : true}
            expandRowByClick={false}
            rowClassName={record => {
              return record.suppress ? styles.tableRow : '';
            }}
            expandedRowRender={record => (
              <RenderInnerSignature
                showSuppress={this.props.showSuppress}
                openDrawer={this.openDrawer}
                record={record}
              />
            )}
            dataSource={filteredResources}
            defaultExpandAllRows={false}
          />
        </Card>
      </Fragment>
    );
  }

  onPaginationChange = pagination => {
    const { current, pageSize, total } = pagination;

    let limit = current * 10 - 10;

    this.setState({
      paginationConfig: pagination,
    });

    let { dispatch, showSuppress } = this.props;
    dispatch({
      type: 'universalDrawer/getFilteredResources',
      payload: {
        limit,
        showSuppress,
      },
    });
  };

  componentDidUpdate = prevProps => {
    if (prevProps.showSuppress !== this.props.showSuppress) {
      let clonePagination = { ...this.state.paginationConfig };
      clonePagination.current = 1;
      this.setState({
        paginationConfig: clonePagination,
      });
    }

    if (prevProps.counts.totalResources !== this.props.counts.totalResources) {
      this.setPagination(this.props.counts.totalResources);
    }

    if (prevProps.appliedFilters !== this.props.appliedFilters) {
      // if (JSON.stringify(prevProps.appliedFilters) !== JSON.stringify(this.props.appliedFilters)) {
      let clonePagination = { ...this.state.paginationConfig };
      clonePagination.current = 1;
      this.setState({
        paginationConfig: clonePagination,
      });
    }
  };

  setPagination = count => {
    this.setState({
      paginationConfig: {
        total: count,
        pageSize: 10,
        current: 1,
        style: { marginRight: 10 },
        hideOnSinglePage: true,
      },
    });
  };

  componentDidMount = () => {
    this.setPagination(this.props.counts.totalResources);
  };

  getTableCloumns() {
    let { allCloudAccountsList, appliedFilters, showSuppress } = this.props;

    return [
      {
        title: 'Resource',
        dataIndex: 'name',
        key: 'id',
        width: 280,
        render: (name, record) => {
          let { risks } = record;
          // risks = risks.filter(v => v.status.toLowerCase() === 'fail');
          let riskLength = risks.length;
          if (!showSuppress) {
            riskLength = risks.filter(v => v.suppress === false).length;
          }
          return (
            <div
              onClick={() => {
                let drawerParams = [
                  {
                    type: 'resourceId',
                    value: [record.id],
                  },
                  {
                    type: 'cloudAccounts',
                    value: [record.cloudAccountId],
                  },
                ];

                // return;
                this.openDrawer(drawerParams, 'singleResource', true);
              }}
              style={{ cursor: 'pointer', fontWeight: 500, fontSize: '13px' }}
            >
              <Badge
                showZero
                count={riskLength}
                overflowCount={1000}
                style={{
                  background: '#228FFD',
                  color: 'white',
                  fontWeight: 600,
                  marginTop: -3,
                  marginRight: 7,
                }}
              />

              {name === '' ? record.id : name}
              <LoginOutlined
                onClick={() => {
                  let drawerParams = [
                    {
                      type: 'resourceId',
                      value: [record.id],
                    },
                    {
                      type: 'cloudAccounts',
                      value: [record.cloudAccountId],
                    },
                  ];
                  // return;
                  this.openDrawer(drawerParams, 'singleResource', true);
                }}
                style={{ color: '#1890FF', marginLeft: '5px' }}
              />
            </div>
          );
        },
      },

      {
        title: 'Service',
        dataIndex: 'service',
        align: 'center',
        key: 'service',
        // width: 80,
        render: service => (
          <Tooltip title={AllServices.getFullName(service)}>
            <Tag style={{ marginLeft: 10, marginRight: 3 }} color="blue">
              {AllServices.getShortName(service)}
            </Tag>
          </Tooltip>
        ),
      },
      {
        title: 'Region',
        align: 'center',
        dataIndex: 'region',
        key: 'region',
        // width: 80,
        render: region => {
          region = region && !Array.isArray(region) ? region : 'Global';
          region = capitalizeFirstLetter(region);
          return (
            <Tooltip title={region}>
              <Tag style={{ marginLeft: 10 }} color="blue">
                {region.length > 15 ? region.substring(0, 15).concat('...') : region}
              </Tag>
            </Tooltip>
          );
        },
      },
      {
        title: 'VPC',
        dataIndex: 'vpcId',
        align: 'center',
        key: 'vpcId',
        width: 70,
        render: vpcId => {
          if (vpcId === '' || vpcId === null || vpcId === undefined) {
            vpcId = 'N/A';
          }
          return (
            <Tooltip title={vpcId}>
              <Tag color="blue">
                {vpcId.length > 6 ? vpcId.substring(0, 6).concat('..') : vpcId}
              </Tag>
            </Tooltip>
          );
        },
      },
      {
        title: <span style={{ textAlign: 'center' }}>Account</span>,
        dataIndex: 'cloudAccountId',
        key: 'cloudAccountId',
        align: 'center',
        // width: 115,
        render: (cloudAccountId, record) => {
          let res = getCloudAccountName(allCloudAccountsList, cloudAccountId);
          if (!res) {
            return null;
          }
          let cloudAccountName = '';
          let provider = '';
          if (res.length > 0) {
            provider = res[0].provider;
            cloudAccountName = res[0].cloudAccountName;
          }
          return (
            <span>
              <Tooltip title={cloudAccountName ? cloudAccountName : ''}>
                <Tag style={{ paddingTop: '2px', marginLeft: 14 }}>
                  {cloudAccountName.length > 8
                    ? cloudAccountName.substring(0, 8).concat('...')
                    : cloudAccountName}
                  {provider && provider === 'AWS' ? (
                    <img
                      src="/awslogo.png"
                      alt="aws"
                      height="18px"
                      style={{ marginBottom: '5px' }}
                    />
                  ) : provider && provider === 'AZURE' ? (
                    <img
                      src="/azure@2x.png"
                      alt="azure"
                      height="18px"
                      style={{ marginBottom: '5px', height: '12px' }}
                    />
                  ) : (
                    <img
                      src="/gcplogo.png"
                      alt="gcp"
                      height="18px"
                      style={{ marginBottom: '2px', height: '20px' }}
                    />
                  )}
                </Tag>
              </Tooltip>
            </span>
          );
        },
      },

      {
        title: 'Health',
        dataIndex: 'progressObj',
        align: 'center',
        key: 'progressObj',
        render: (progressObj, record) => {
          let { risks } = record;
          // risks = risks.filter(v => v.status.toLowerCase() === 'fail');
          let riskLength = risks.length;
          if (!showSuppress) {
            riskLength = risks.filter(v => v.suppress === false).length;
          }
          return (
            <div style={{ marginTop: 8 }}>
              <RenderProgressBar type="risks" risks={progressObj} />
            </div>
          );
        },
      },
      {
        title: 'Suppress',
        dataIndex: 'suppress',
        align: 'center',
        key: 'suppress',
        render: (name, record, i) => {
          let suppressProps = {
            type: 'resource',
            record: record,
            i: i,
          };
          return <FinderSuppressReason {...suppressProps} />;
        },
      },
    ];
  }
}

export default ResourceRiskTable;

function sortData(data) {
  // return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
  return data.sort((a, b) => {
    let pass = a.status.toLowerCase();
    let fail = b.status.toLowerCase();

    if (pass < fail) {
      return -1;
    } else if (pass > fail) {
      return 1;
    }
    return 0;
  });
}

function getUnSuppressedRisks(data) {
  return data.filter(v => v.suppress === false);
}
